import React from 'react';
import { FaEdit, FaHeart, FaComments, FaRing } from 'react-icons/fa';

const HowItWorks = () => {
  const steps = [
    {
      number: "01",
      title: "Create Your Profile",
      description: "Tell us about yourself, your preferences, and what you're looking for in a partner.",
      icon: <FaEdit className="text-3xl text-pink-400" />
    },
    {
      number: "02",
      title: "Find Your Matches",
      description: "Our intelligent algorithm suggests compatible partners based on your preferences.",
      icon: <FaHeart className="text-3xl text-pink-400" />
    },
    {
      number: "03",
      title: "Start Connecting",
      description: "Send messages, like profiles, and build meaningful connections with your matches.",
      icon: <FaComments className="text-3xl text-pink-400" />
    },
    {
      number: "04",
      title: "Meet Your Soulmate",
      description: "Take the next step and meet the person who could be your perfect life partner.",
      icon: <FaRing className="text-3xl text-pink-400" />
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-transparent relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-50"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20 animate-fade-in-up">
          <span className="text-pink-400 font-semibold tracking-wider uppercase text-sm mb-2 block">Process</span>
          <h2 className="text-4xl lg:text-5xl font-romantic font-bold text-white mb-6">
            How It <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-rose-400">Works</span>
          </h2>
          <p className="text-xl text-white max-w-2xl mx-auto">
            Finding your perfect match is simple and secure with our 4-step process.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative text-center group" style={{ animationDelay: `${index * 0.15}s` }}>
              {/* Connecting Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-pink-500/20 to-purple-500/20 z-0"></div>
              )}
              
              <div className="relative z-10 p-8 rounded-[2rem] romantic-glass-card group-hover:-translate-y-4 transition-all duration-500">
                <div className="w-20 h-20 mx-auto mb-8 relative">
                  <div className="absolute inset-0 bg-pink-500/10 rounded-3xl transform rotate-6 group-hover:rotate-12 transition-transform duration-300"></div>
                  <div className="absolute inset-0 bg-[#120720] rounded-3xl shadow-sm border border-pink-500/20 flex items-center justify-center transform -rotate-3 group-hover:rotate-0 transition-transform duration-300">
                    {step.icon}
                  </div>
                  <div className="absolute -top-3 -right-3 w-8 h-8 bg-gradient-to-tr from-pink-500 to-rose-500 rounded-full flex items-center justify-center text-white text-sm font-bold shadow-lg border-2 border-[#120720] group-hover:scale-110 transition-transform duration-300">
                    {step.number}
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-white mb-4 group-hover:text-pink-400 transition-colors">
                  {step.title}
                </h3>
                
                <p className="text-slate-300 leading-relaxed text-sm">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;